<div class="pill {{ !editable && 'dull' }}" *ngIf="selectedOption">
  <span class="icon-container">
    <img [src]="selectedOption.icon" class="icon" />
  </span>
  {{ selectedOption.value.text }}
</div>